import React from "react";
import cs from "classnames";
import get from "lodash/get";
import format from "date-fns/format";
import startOfMinute from "date-fns/start_of_minute";

import accounting from "~/misc/accounting";
import weightFormat from "~/misc/weight";
import * as equipment from "~/misc/equipment";
import AgeLabel from "~/components/AgeLabel";

import css from "./Row.css";

const NColumn = (props) => (
  <div
    className={cs(css.nColumn, props.className)}
    title={props.title}
    data-qa={props["data-qa"]}
  >
    {props.children}
  </div>
);

const LoadRow = (props) => {
  const i = props.data;
  const fullSize = i.load_size === "full";
  const equipmentText = i.equipment
    .map((eq) => get(equipment.humanLowerCaseToId, eq, "Any"))
    .join(" ");
  const equipmentTitle = i.equipment
    .map((eq) => get(equipment.humanLowerCaseToFull, eq, "Any"))
    .join(", ");
  const isLoggedIn = true;
  const renderContent = () => {
    return (
      <NColumn
        className={cs("qa-search-results-broker", css.nColumnBroker)}
        title={i.broker.company ? i.broker.company : "—"}
      >
        {i.broker.company ? i.broker.company : "—"}
      </NColumn>
    );
  };
  return (
    <a
      className={cs(css.itemShape, css.item, css.freshloads, {
        [css.compactView]: props.compactView,
      })}
      href={`/loads/${i.id}`}
    >
      <NColumn className={css.nColumnEmpty}></NColumn>
      <NColumn className={cs(css.nColumnAge)}>
        <AgeLabel
          className={css.ageLabel}
          properAge={
            i.pickup.date_local &&
            Math.max(
              startOfMinute(new Date()) -
                new Date(i.pickup.date_local).valueOf(),
              0
            )
          }
          deleted={false}
          viewed={false}
        />
      </NColumn>

      <NColumn
        className={cs(
          "qa-search-result-pickup",
          css.nColumnPickupDate,
          css.tac
        )}
        title={format(i.pickup.date_local, "MMM D")}
      >
        {format(i.pickup.date_local, "MMM D")}
      </NColumn>
      <NColumn
        className={cs(
          "qa-search-results-dho",
          css.nColumnPickupDeadhead
          // css.numbers
        )}
      >
        <div className={cs(css.tripProp, css.tripPropPickupDeadhead)}>
          {i.pickup.deadhead ? `${parseInt(i.pickup.deadhead)} mi` : "—"}
        </div>
      </NColumn>
      <NColumn
        className={cs(
          "qa-search-result-origin-city",
          css.nColumnPickupName,
          css.tac
        )}
        title={i.pickup.address.city && i.pickup.address.city}
      >
        <div className={cs(css.tripProp, css.tripPropPickupName)}>
          {i.pickup.address.city && i.pickup.address.city}
        </div>
      </NColumn>

      <NColumn
        className={cs(
          "qa-search-result-origin-state",
          css.nColumnPickupState,
          css.tac
        )}
      >
        <div className={cs(css.tripProp, css.tripPropPickupState)}>
          {i.pickup.address.state}
        </div>
      </NColumn>
      {/* <NColumn className={cs(css.nColumnDropoffDeadhead, css.numbers)}>
        <div className={cs(css.tripProp, css.tripPropDropoffDeadhead)}>
          {i.drop_off.deadhead ? `${parseInt(i.drop_off.deadhead)} mi` : "—"}
        </div>
      </NColumn> */}
      <NColumn
        className={cs(
          "qa-search-result-destination-city",
          css.nColumnDropffName,
          css.tac
        )}
        title={i.drop_off.address.city && i.drop_off.address.city}
      >
        <div className={cs(css.tripProp, css.tripPropDropffName)}>
          {i.drop_off.address.city && i.drop_off.address.city}
        </div>
      </NColumn>
      <NColumn
        className={cs(
          "qa-search-result-destination-state",
          css.nColumnDropoffState,
          css.tac
        )}
      >
        <div className={cs(css.tripProp, css.tripPropDropoffState)}>
          {i.drop_off.address.state}
        </div>
      </NColumn>
      <NColumn
        data-qa={"search-result-trip"}
        className={cs(css.nColumnTrip, css.numbers)}
      >
        {i.distance ? `${accounting.formatNumber(i.distance)} mi` : "—"}
      </NColumn>
      <div className={css.truckPropsGroup}>
        <NColumn
          data-qa="search-result-length"
          className={cs(css.truckPropColumn, css.nColumnLength, css.numbers)}
        >
          {i.length ? `${i.length}ft` : "—"}
        </NColumn>
        <NColumn
          className={cs(
            "qa-search-results-weight",
            css.truckPropColumn,
            css.nColumnWeight,
            css.numbers
          )}
          title={`${accounting.formatNumber(i.weight)} lbs`}
        >
          {weightFormat(i.weight)}
        </NColumn>
        <NColumn className={cs(css.truckPropColumn, css.nColumnSize, css.tac)}>
          <span
            title={`Load Size: ${i.load_size}`}
            className={cs("qa-search-results-size", css.sizeIcon, {
              [css.sizeFull]: fullSize,
              [css.sizePartial]: !fullSize,
              "qa-search-results-size-full": fullSize,
              "qa-search-results-size-partial": !fullSize,
            })}
          />
        </NColumn>
        <NColumn
          className={cs(
            "qa-search-result-equipment",
            css.truckPropColumn,
            css.nColumnEquipment,
            css.tac
          )}
          title={equipmentTitle}
        >
          {equipmentText}
        </NColumn>
      </div>
      <div className={css.brokerGroup}>
        <NColumn
          className={cs(
            "qa-search-results-price",
            css.nColumnPrice,
            css.numbers
          )}
        >
          <span>{accounting.formatMoney(i.price) || "—"}</span>
        </NColumn>
        <NColumn
          className={cs("qa-premium-cell", css.nColumnPremium)}
        ></NColumn>
        {isLoggedIn ? (
          renderContent()
        ) : (
          <NColumn
            className={cs("qa-search-results-broker", css.nColumnBroker)}
            title={"—"}
          >
            {"—"}
          </NColumn>
        )}
      </div>
    </a>
  );
};

export default LoadRow;



// WEBPACK FOOTER //
// ./src/components/LoadPage/SimilarLoads/Row.js